import {
  MOON_100,
  MOON_250,
  MOON_500,
  MOON_800,
  TEAL_300,
  TEAL_600,
} from '@wandb/weave/common/css/color.styles';
import {hexToRGB} from '@wandb/weave/common/css/utils';
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const OptionCreateNewArtifactOuter = styled.div`
  border-top: 1px solid ${MOON_250};
  cursor: pointer;
  padding: 4px 6px;
  width: auto;
`;
OptionCreateNewArtifactOuter.displayName = 'S.OptionCreateNewArtifact';

export const OptionCreateNewArtifact = styled.div<{isSelected?: boolean}>`
  padding: 14px 10px;
  color: ${props => (props.isSelected ? TEAL_600 : MOON_800)};
  border-radius: 4px;
  &:hover {
    background-color: ${props =>
      props.isSelected ? hexToRGB(TEAL_300, 0.32) : MOON_100};
  }
  background-color: ${props =>
    props.isSelected ? hexToRGB(TEAL_300, 0.32) : ''};
`;
OptionCreateNewArtifact.displayName = 'S.OptionCreateNewArtifact';

export const SelectOption = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
SelectOption.displayName = 'S.SelectOption';

export const SelectOptionLabel = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 4px;
  flex: 1 1 auto;
`;
SelectOptionLabel.displayName = 'S.SelectOptionLabel';

export const SelectOptionLabelIcon = styled(Icon)`
  margin-top: 4px;
  margin-bottom: auto;
`;
SelectOptionLabelIcon.displayName = 'S.SelectOptionLabelIcon';

export const SelectOptionLabelText = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
`;
SelectOptionLabelText.displayName = 'S.SelectOptionLabelText';

export const SelectOptionSubLabelText = styled.span`
  font-size: 14px;
  color: ${MOON_500};
  line-height: 20px;
`;
SelectOptionSubLabelText.displayName = 'S.SelectOptionSubLabelText';
